import "./bootstrap";

import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";

import swal from "sweetalert2";
window.Swal = swal;

